import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const inmateRequestsRoutes: RouteObject[] = [
  {
    path: '/inmate-requests/groups',
    element: lazyElement(() => import('./Groups/List')),
    handle: {
      documentTitle: 'Inmate Requests Groups',
      crumb: () => ({ label: 'Inmate Requests Groups', to: '/inmate-requests/groups' })
    },
  },
  {
    path: '/inmate-requests/forms',
    element: lazyElement(() => import('./Forms/List')),
    handle: {
      documentTitle: 'Inmate Requests Forms',
      crumb: () => ({ label: 'Inmate Requests Forms', to: '/inmate-requests/forms' })
    },
  },
];

export default inmateRequestsRoutes;
